module.exports = __webpack_public_path__ + "img/LENS.65640e48.png";